import { render, staticRenderFns } from "./HomeworksOnlyMobile.vue?vue&type=template&id=7a356962&scoped=true&"
import script from "./HomeworksOnlyMobile.vue?vue&type=script&lang=js&"
export * from "./HomeworksOnlyMobile.vue?vue&type=script&lang=js&"
import style0 from "./HomeworksOnlyMobile.vue?vue&type=style&index=0&id=7a356962&prod&lang=scss&scoped=true&"
import style1 from "./HomeworksOnlyMobile.vue?vue&type=style&index=1&id=7a356962&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a356962",
  null
  
)

export default component.exports